/** A roof face's wind zones (most suction first) and its rafter check, under the face's row of the Structure step's
 * results: "zone 3 · 2 panels · GCp −3.0 · every 16 in". */
import { Badge } from "../components/ui";
import { useT } from "../i18n/I18nProvider";
import { zonesBySuction, type ZoneRow } from "../lib/permitAhj";
import { STATUS_LABEL, STATUS_TONE, type CheckStatus } from "../lib/permits";
import { formatLength, type Units } from "../lib/permitWorkspace";
import { useFormat } from "./format";

export function ZoneDetails({ face, units }: { face: Record<string, unknown>; units: Units }) {
  const t = useT();
  const f = useFormat();
  const zones = zonesBySuction(face.zones as ZoneRow[] | undefined);
  const rafter = face.rafter as { status: CheckStatus; detail: string } | null | undefined;
  if (!zones.length && !rafter) return null;
  return (
    <div className="pw-zones">
      {zones.map((z) => (
        <div key={z.zone} className="pw-zone">
          <span className={`pw-zone-chip z${z.zone.replace("'", "p")}`}>{t("permit.zones.chip", { zone: z.zone })}</span>
          <span>{t("permit.zones.row", { count: z.panels, exposed: z.exposed || 0, gcp: f.num(z.gcp, 1), spacing: formatLength(z.attachment_spacing_m, units, f.digits) })}</span>
          {z.status === "problem" && <Badge tone="danger">{t("permit.checkStatus.problem")}</Badge>}
        </div>
      ))}
      {rafter && (
        <div className="pw-zone">
          <Badge tone={STATUS_TONE[rafter.status]}>{rafter.status === "info" ? t("permit.zones.framing") : t(STATUS_LABEL[rafter.status])}</Badge>
          <span>{rafter.detail}</span>
        </div>
      )}
    </div>
  );
}
